import { requiredPassword } from "@/lib/utils/zod";

export const passwordSchema = requiredPassword(
  "Password is required",
).superRefine((password, context) => {
  const passwordLength = Array.from(password).length;

  if (passwordLength > 128) {
    context.addIssue({
      code: "custom",
      message: "Password must be at most 128 characters long.",
    });
    return;
  }

  const problems: Array<string> = [];

  if (passwordLength < 8) problems.push("be at least 8 characters long");

  const requiredCharacterTypes: Array<[RegExp, string]> = [
    [/[a-z]/, "a lowercase letter"],
    [/[A-Z]/, "an uppercase letter"],
    [/[0-9]/, "a digit"],
    [/[^a-zA-Z0-9]/, "a symbol"],
  ];
  const missingCharacterTypes = requiredCharacterTypes
    .filter(([pattern]) => !pattern.test(password))
    .map(([, label]) => label);

  if (missingCharacterTypes.length > 0) {
    const lastCharacterType = missingCharacterTypes.at(-1);
    const formattedCharacterTypes =
      missingCharacterTypes.length === 1
        ? lastCharacterType
        : `${missingCharacterTypes.slice(0, -1).join(", ")} and ${lastCharacterType}`;

    problems.push(`contain ${formattedCharacterTypes}`);
  }

  if (problems.length > 0) {
    context.addIssue({
      code: "custom",
      message: `Password must ${problems.join(" and ")}.`,
    });
  }
});
